import Vue from "vue";
import $ from 'jquery';

Vue.directive('password-strength', {
    // eslint-disable-next-line no-unused-vars
        componentUpdated: function (el, bingding) {
            const valueInput = el.value;
            if (valueInput && valueInput.length > 0) {
                $(el).passwordStrength({isVuejs: true, value: valueInput});
            } else {
                $(el).dismiss({isVuejs: true, element: el});
            }
        }
    }
);
